<script setup lang="ts">
import {viewportSize} from '@teemill/common/helpers';
import {RetexItem} from './types/retexItem';

defineProps<{
  refundItem: RetexItem;
}>();

const mobileView = viewportSize.isSmaller('md');
</script>

<template>
  <tml-item-tray
    :flex-ratio="mobileView ? '1:2' : '1:5'"
    no-wrap
    spacing="1rem"
    class="mr-8"
  >
    <template #primary>
      <tml-image
        class="rounded-full"
        object-fit="contain"
        :src="refundItem.images ? refundItem.images['640'] : undefined"
        :alt="refundItem.product.name"
      />
    </template>
    <template #secondary>
      <div class="block">
        <component
          :is="mobileView ? 'h5' : 'h4'"
          class="font-bold text-wrap mb-0"
        >
          {{ refundItem.product.name }}
        </component>
        <p v-if="refundItem.options.size" :class="{'text-sm': mobileView}">
          Size: {{ refundItem.options.size }}
        </p>
        <p v-if="refundItem.options.colour" :class="{'text-sm': mobileView}">
          Colour: {{ refundItem.options.colour }}
        </p>
        <p v-if="refundItem.quantity" class="text-sm lg:text-base">
          Quantity: {{ refundItem.quantity }}
        </p>
      </div>
    </template>
  </tml-item-tray>
</template>
